import { ActionType } from '../infrastructure/actionTypes';

export interface ILoadingState {
  isBusy: boolean;
}

const loadingInitialState: ILoadingState = {
  isBusy: false,
};

export default (state = loadingInitialState, action: any) => {
  switch (action.type) {
    case ActionType.START_LOADING:
    case ActionType.LOGGING_IN:
      return { isBusy: true };
    case ActionType.STOP_LOADING:
    case ActionType.LOGGED_IN:
    case ActionType.LOGGED_OUT:
    case ActionType.LOGIN_FAILED:
      return { isBusy: false };
    default:
      return state;

  }
};



// WEBPACK FOOTER //
// ./src/reducers/loading.ts